import styles from './styles.module.scss'
import Button from '../../elements/Button'
import { useState, useCallback, useEffect } from 'react'
import { withModifiers } from '../../helpers/withModifiers'

const Review = ({ date, title, content, name }) => {
  const [open, setOpen] = useState(false)
  const [loaded, setLoaded] = useState(false)
  const [height, setHeight] = useState(false)
  const [smallHeight, setSmallHeight] = useState(false)

  const measuredRef = useCallback((node) => {
    if (node !== null) {
      setHeight(node.scrollHeight)
      setSmallHeight(node.offsetHeight)
      setLoaded(true)
    }
  }, [])

  useEffect(() => setLoaded(true))

  if (loaded) {
    return (
      <div className={styles.review}>
        <div className={styles.review__date}>{date}</div>

        <h3 className={styles.review__title}>{title}</h3>

        <div className={styles.review__wrapper}>
          <p
            className={styles.review__content}
            style={{ display: open ? 'none' : '-webkit-box' }}
            ref={measuredRef}
          >
            {content}
          </p>

          <p
            className={withModifiers('review__content', ['secondary'], styles)}
            style={{
              maxHeight:
                height !== smallHeight && (open ? height : smallHeight),
              opacity: !open && 0
            }}
          >
            {content}
          </p>

          {height !== smallHeight && (
            <Button
              onClick={() => setOpen(!open)}
              arrow={false}
              variant={['label', 'blue', 'xs']}
            >
              Read {open ? 'less' : 'more'}
            </Button>
          )}
        </div>

        <div className={styles.review__name}>{name}</div>
      </div>
    )
  }
  return
}

export default Review
